module.exports = __webpack_public_path__ + "img/pernambuco.2db1fb8c.jpg";